<template>
  <section id="assist__rank">
    <div class="top">
      <h2>助力排行榜</h2>
      <p v-if="data.assist_status == 1">还有 {{ remaining }} 个助力名额</p>
    </div>
    <div class="rank" v-if="data.assist_user.length">
      <div class="rank__item" v-for="(item, index) in data.assist_user" :key="item.user_id">
        <div class="num">{{ index + 1 }}</div>
        <div class="img" :style="$bgd(item.gravatar)"></div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <div v-if="!isSelf" class="bottom">
      <div v-if="data.assist_status == 1 && isAllowedAssist">
        <div v-if="!isLoading" class="btn-primary" @click="assist">
          <i class="anyteachicon anyteach-zhulihuodong" />
          <span>点击助力</span>
        </div>
        <div v-else class="btn-primary disabled">
          <i class="anyteachicon anyteach-zhulihuodong" />
          <span>点击助力</span>
        </div>
        <div class="btn-hint">赢取 3 集趣蒙视频课</div>
      </div>
      <p class="body" v-else-if="isAllowedAssist">助力已结束，发起一个新的助力吧！</p>
      <div v-else class="animated fadeIn">
        <router-link tag="div" class="btn-primary" to="/assist/video">
          <i class="anyteachicon anyteach-gift" />
          <span>我的助力奖励</span>
        </router-link>
        <div class="hint">
          <span class="btn-hint">您已参与过助力，也可以发起</span>
          <router-link tag="span" class="btn-link" to="/assist/rule">新的助力</router-link>
        </div>
      </div>
    </div>
    <div v-else class="bottom">
      <div v-if="data.assist_status == 1">
        <div @click="$emit('poster')" class="btn-primary">
          <i class="anyteachicon anyteach-post"></i>
          <span>生成海报</span>
        </div>
        <div class="btn-hint">邀请好友完成助力！</div>
      </div>
      <div v-else>
        <div class="btn-hint">本次助力已结束，向下滑动查看奖励</div>
      </div>
    </div>
  </section>
</template>

<script>
import Rule from "../rule/Rule"
export default {
  name: "AssistRank",
  props: ["data", "isSelf", "isAllowedAssist"],
  components: { Rule },
  computed: {
    remaining() {
      return this.data.limit_time - this.data.assist_user.length
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    assist() {
      this.isLoading = true
      this.$emit("assist")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
#assist__rank {
  .top {
    text-align: center;
    h2 {
      margin-bottom: 10px;
    }
    p {
      @include body();
    }
  }
}
.rank {
  background: $grey;
  padding: 20px;
  width: calc(100% - 60px);
  max-width: 400px;
  margin: 15px auto 0 auto;
  border-radius: 4px;
  .rank__item {
    display: flex;
    align-items: center;
    margin: 0 0 10px 0;
  }
  .rank__item:last-of-type {
    margin: 0;
  }
  .num,
  .img,
  .name {
    margin: 0;
    padding: 0;
  }
  .num {
    @include avenir-demi();
    color: $purple;
    font-size: 1rem;
    text-align: right;
    padding-right: 10px;
    width: 25px;
  }
  .img {
    $size: 25px;
    min-width: $size;
    min-height: $size;
    border-radius: 50%;
    margin-right: 5px;
  }
  .right {
    display: flex;
    align-items: center;
  }
  .name {
    @include avenir-demi();
    font-size: 0.8rem;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}

.hint {
  margin: 5px 0 0 0;
  font-size: 0.8rem;
  text-align: center;
}

.bottom {
  margin: 15px 0 0 0;
}
</style>
